const Actions = {
  /* View state actions */
  ACTIVATE_CHATBOT_EDITOR: 'ACTIVATE_CHATBOT_EDITOR',
  ACTIVATE_PAGE_EDITOR: 'ACTIVATE_PAGE_EDITOR',
  APPEND_APP_NAVIGATION_HISTORY: 'APPEND_APP_NAVIGATION_HISTORY',
  SET_LANDMINE_OPEN_ID: 'SET_LANDMINE_OPEN_ID',
  DEACTIVATE_PAGE_EDITOR: 'DEACTIVATE_PAGE_EDITOR',
  SHOW_CONFIRM_DELETE_CHATBOT: 'SHOW_CONFIRM_DELETE_CHATBOT',
  HIDE_CONFIRM_DELETE_CHATBOT: 'HIDE_CONFIRM_DELETE_CHATBOT',
  SHOW_CONFIRM_DELETE_PAGE: 'SHOW_CONFIRM_DELETE_PAGE',
  HIDE_CONFIRM_DELETE_PAGE: 'HIDE_CONFIRM_DELETE_PAGE',
  SHOW_CONFIRM_DELETE_PAGE_GROUP: 'SHOW_CONFIRM_DELETE_PAGE_GROUP',
  HIDE_CONFIRM_DELETE_PAGE_GROUP: 'HIDE_CONFIRM_DELETE_PAGE_GROUP',
  ACTIVATE_PAGE_EDITOR_FORM_FIELD: 'ACTIVATE_PAGE_EDITOR_FORM_FIELD',
  ACTIVATE_PROPERTIES_PANE: 'ACTIVATE_PROPERTIES_PANE',
  SET_FACEBOOK_ACCESS_TOKEN: 'SET_FACEBOOK_ACCESS_TOKEN',
  START_UPLOAD_IMAGE: 'START_UPLOAD_IMAGE',
  FINISH_UPLOAD_IMAGE: 'FINISH_UPLOAD_IMAGE',
  START_UPLOAD_VIDEO: 'START_UPLOAD_VIDEO',
  FINISH_UPLOAD_VIDEO: 'FINISH_UPLOAD_VIDEO',
  START_UPLOAD_AUDIO: 'START_UPLOAD_VIDEO',
  FINISH_UPLOAD_AUDIO: 'FINISH_UPLOAD_VIDEO',
  START_UPLOAD_FILE: 'START_UPLOAD_FILE',
  FINISH_UPLOAD_FILE: 'FINISH_UPLOAD_FILE',
  SET_ENV: 'SET_ENV',
  DB_INIT: 'DB_INIT',
  SHOW_FACEBOOK_CONNECT_MODAL: 'SHOW_FACEBOOK_CONNECT_MODAL',
  HIDE_FACEBOOK_CONNECT_MODAL: 'HIDE_FACEBOOK_CONNECT_MODAL',
  SHOW_CREATE_BOT_MODAL: 'SHOW_CREATE_BOT_MODAL',
  HIDE_CREATE_BOT_MODAL: 'HIDE_CREATE_BOT_MODAL',
  SELECT_MAIN_MENU: 'SELECT_MAIN_MENU',
  UNSELECT_MAIN_MENU: 'UNSELECT_MAIN_MENU',
  AD_CONFIGS_SELECT_AD: 'AD_CONFIGS_SELECT_AD',
  AD_CONFIGS_UNSELECT_AD: 'AD_CONFIGS_UNSELECT_AD',
  CTM_ADS_SELECT_AD: 'CTM_ADS_SELECT_AD',
  CTM_ADS_UNSELECT_AD: 'CTM_ADS_UNSELECT_AD',
  MESSENGER_ADS_SELECT_AD: 'MESSENGER_ADS_SELECT_AD',
  MESSENGER_ADS_UNSELECT_AD: 'MESSENGER_ADS_UNSELECT_AD',
  RESET: 'RESET',
  SHOW_DELETE_ERROR_MODAL: 'SHOW_DELETE_ERROR_MODAL',
  HIDE_DELETE_ERROR_MODAL: 'HIDE_DELETE_ERROR_MODAL',
  SHOW_SLIDEOUT_MENU: 'SHOW_SLIDEOUT_MENU',
  HIDE_SLIDEOUT_MENU: 'HIDE_SLIDEOUT_MENU',
  SHOW_CHECKLIST_TOOLTIP: 'SHOW_CHECKLIST_TOOLTIP',
  HIDE_CHECKLIST_TOOLTIP: 'HIDE_CHECKLIST_TOOLTIP',
  UNBUSY: 'UNBUSY',
  START_GET_GIF_PREDICTIONS: 'START_GET_GIF_PREDICTIONS',
  FINISH_GET_GIF_PREDICTIONS: 'FINISH_GET_GIF_PREDICTIONS',
  START_DOWNLOADING_GIF: 'START_DOWNLOADING_GIF',
  END_DOWNLOADING_GIF: 'END_DOWNLOADING_GIF',
  RSS_FEEDS_SELECT_FEED: 'RSS_FEEDS_SELECT_FEED',
  RSS_FEEDS_UNSELECT_FEED: 'RSS_FEEDS_UNSELECT_FEED',
  LANDING_PAGES_SELECT_ENTITY: 'LANDING_PAGES_SELECT_ENTITY',
  LANDING_PAGES_UNSELECT_ENTITY: 'LANDING_PAGES_UNSELECT_ENTITY',
  SET_DASHBOARD_PAGINATION_PAGE: 'SET_DASHBOARD_PAGINATION_PAGE',
  SHOW_WIDGET_ERROR_MODAL: 'SHOW_WIDGET_ERROR_MODAL',
  HIDE_WIDGET_ERROR_MODAL: 'HIDE_WIDGET_ERROR_MODAL',
  NOTIFY_MANDATORY_UPDATE: 'NOTIFY_MANDATORY_UPDATE',
  NOTIFY_RECOMMENDED_UPDATE: 'NOTIFY_RECOMMENDED_UPDATE',
  DISMISS_UPDATE_NOTIFICATION: 'DISMISS_UPDATE_NOTIFICATION',
  AD_ENTITIES_BUSY: 'AD_ENTITIES_BUSY',
  AD_ENTITIES_UNBUSY: 'AD_ENTITIES_UNBUSY',
  RETRIEVED_AD_SETS: 'RETRIEVED_AD_SETS',
  RETRIEVED_ADS: 'RETRIEVED_ADS',
  RETRIEVED_SYNCED_ADS: 'RETRIEVED_SYNCED_ADS',
  SET_REQUEST_DEMO_SNOOZE_DATE: 'SET_REQUEST_DEMO_SNOOZE_DATE',
  SET_SUPPRESS_BOT_WIDGET: 'SET_SUPPRESS_BOT_WIDGET',
  VIEW_HIDE_BETA_SUBNAV: 'VIEW_HIDE_BETA_SUBNAV',
  VIEW_SHOW_BETA_SUBNAV: 'VIEW_SHOW_BETA_SUBNAV',
  DISABLE_MAIN_SCROLL: 'DISABLE_MAIN_SCROLL',
  ENABLE_MAIN_SCROLL: 'ENABLE_MAIN_SCROLL',
  SET_WIDGET_TO_FOCUS: 'SET_WIDGET_TO_SCROLL',
  SET_FACEBOOK_PAGE_ERRORS: 'SET_FACEBOOK_PAGE_ERRORS',
  REMOVE_FACEBOOK_PAGE_ERROR: 'REMOVE_FACEBOOK_PAGE_ERROR',
};

export default Actions;
